import axios from 'axios'

const actions = {

  fetchCourierStatisticTables ({ rootGetters, dispatch }, meta) {
    meta = meta || {}

    /* Make unique request, other pending will be canceled */
    const url = rootGetters['api/fetchCourierStatisticTables']
    const source = axios.CancelToken.source()
    dispatch('requests/addUniqueRequest', { url, source }, { root: true })

    return axios
      .get(url, {
        params: meta,
        cancelToken: source.token,
      })
      .then(res => {
        return res.data.items
      })
  },

  fetchMenuAbcStatistic ({ rootGetters, dispatch }, meta) {
    meta = meta || {}

    /* Make unique request, other pending will be canceled */
    const url = rootGetters['api/fetchMenuAbcStatistic']
    const source = axios.CancelToken.source()
    dispatch('requests/addUniqueRequest', { url, source }, { root: true })

    return axios
      .get(url, {
        params: meta,
        cancelToken: source.token,
      })
      .then(res => {
        return res.data.items
      })
  },

  fetchMoneyByTypeStatistic ({ rootGetters, dispatch }, meta) {
    meta = meta || {}

    /* Make unique request, other pending will be canceled */
    const url = rootGetters['api/fetchMoneyByTypeStatistic']
    const source = axios.CancelToken.source()
    dispatch('requests/addUniqueRequest', { url, source }, { root: true })

    return axios
      .get(url, {
        params: meta,
        cancelToken: source.token,
      })
      .then(res => {
        return res.data.items
      })
  },

  downloadMoneyByTypeStatistic ({ rootGetters, dispatch }, meta) {
    meta = meta || {}

    /* Make unique request, other pending will be canceled */
    const url = rootGetters['api/downloadMoneyByTypeStatistic']
    const source = axios.CancelToken.source()
    dispatch('requests/addUniqueRequest', { url, source }, { root: true })

    return axios
      .get(url, {
        params: meta,
        cancelToken: source.token,
        responseType: 'blob',
      })
      .then(res => {
        // create file link in browser's memory
        const href = URL.createObjectURL(res.data)

        // create "a" HTML element with href to file & click
        const link = document.createElement('a')
        link.href = href
        const fileName = `fact_statistic_filials_money_metrics_${meta.from}-${meta.to}.xlsx`
        link.setAttribute('download', fileName) // or any other extension
        document.body.appendChild(link)
        link.click()

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link)
        URL.revokeObjectURL(href)
        return true
      })
  },
}

export default {
  namespaced: true,
  actions,
}
